export default __webpack_public_path__ + "static/media/happy_heart.b3c9d659.png";